import * as Sentry from '@sentry/vue';

export default {
  install(Vue) {
    Sentry.init({
      Vue,
      trackComponents: true,
      dsn: process.env.SENTRY_DSN,
      tracesSampleRate: Number(process.env.SENTRY_SAMPLE_RATE),
      attachStacktrace: process.env.SENTRY_ATTACH_STACK_TRACE === 'true',
      environment: process.env.SENTRY_ENV,
      debug: process.env.SENTRY_DEBUG === 'true',
      normalizeDepth: 10,
      integrations: [
        Sentry.extraErrorDataIntegration({
          // Limit of how deep the object serializer should go. Anything deeper than limit will
          // be replaced with standard Node.js REPL notation of [Object], [Array], [Function] or
          // a primitive value. Defaults to 3.
          depth: 10,
        }),
      ],
    });

    if (window?.USER?.id) {
      Sentry.setUser({
        id: `${window.USER.id}`,
        username: `${window.USER.username}`,
        email: `${window.USER.email}`,
      });
    }
  },
  log(source, error) {
    Sentry.captureException({source, ...error});
  },
};
